import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router'

import FirebaseAuthPlugin from './plugins/FirebaseAuthPlugin'

Vue.use(FirebaseAuthPlugin)

Vue.config.productionTip = false

sync(store, router)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
